import React from 'react';

const GreyDividerDot = () => {
	return <div className="grey-dot m-[1rem] ml-[1rem]"></div>;
};

export default GreyDividerDot;
